module.exports = __webpack_public_path__ + "img/icon_map_51_off_010.d4ae3f48.png";